export default [
  {
    "type": "cc",
    "name": "Saskia Sassen",
    "picture": "saskiasassen.jpg",
    "org": null,
    "instagram": null,
    "twitter": "SaskiaSassen",
    "facebook": null,
    "bio": "Profesora de sociología de la cátedra Robert S. Lynd en la Universidad de Columbia y miembro del Comité de Pensamiento Global por la misma universidad. Sus últimos libros son Ciudades en Guerra con Mary Kaldor (Columbia University Press 2020), la quinta edición completamente actualizada de Ciudades en la Economía Global (Sage 2018), y Expulsiones: brutalidad y complejidad en la economía global (Harvard University Press 2014, ahora en 18 idiomas.) Ha recibido diversos premios, incluyendo múltiples doctores honoris causa, el Príncipe de Asturias 2013 Premio en Ciencias Sociales, y fue nombrada Miembro internacional de la Real Academia de Ciencias de Holanda. <br><br>Más información en www.saskiasassen.com"
  },
  {
    "type": "cc",
    "name": "Guillermo Peñalosa",
    "picture": "guillermopenalosa.jpg",
    "org": "8 80 cities",
    "instagram": "penalosagmo",
    "twitter": null,
    "facebook": null,
    "bio": "MBA, PhDhc, CSP<br>Fundador y Presidente, 8 Embajador de 80 Ciudades , Presidente Mundial de Parques Urbanos, Gil Penalosa & Associates<br><br>Gil (Guillermo) Penalosa es un apasionado de crear ciudades para todas las personas. Ha inspirado y asesorado a los tomadores de decisiones en más de 350 ciudades diferentes de todo el mundo sobre cómo crear ciudades vibrantes con comunidades saludables donde todas las personas puedan vivir más felices, independientemente de su edad, género, capacidad o condición socioeconómica o étnica.<br>Gil es fundador y presidente de 8 80 Cities, una organización internacional sin fines de lucro con base en Canadá, basada en un concepto simple pero poderoso: ¿Qué pasaría si todo lo que hiciéramos en nuestras ciudades tuviera que ser excelente para un niño de 8 años de edad y de 80 años? <br>https://www.gpenalosa.ca/"
  },
  {
    "type": "cc",
    "name": "Clara Muzzio",
    "picture": "claramuzzio.jpg",
    "org": "Ministra de Espacio Público e Higiene Urbana- GCBA",
    "instagram": "clara.muzzio",
    "twitter": "claramuzzio",
    "facebook": null,
    "bio": "Clara Muzzio es abogada y Magister en Administración y Políticas Públicas. Desde diciembre de 2019 conduce el Ministerio de Espacio Público e Higiene Urbana del Gobierno de la Ciudad de Buenos Aires.<br>Se convirtió en ministra tras un recorrido de casi 10 años por distintas áreas del Ministerio de Ambiente y Espacio Público, desde donde implementó las políticas para redimensionar la ciudad a escala humana, garantizar el desarrollo urbano sustentable y promover el uso correcto del espacio público.<br>Fue Gerente de Ordenamiento de Uso de Espacio Público, Directora del Plan Microcentro, Directora de Regeneración Urbana, Subsecretaria de Uso del Espacio Público y Subsecretaria de Vías Peatonales."
  },
  {
    "type": "cc",
    "name": "Marcela Mondino",
    "picture": "marcelamondino.jpg",
    "org": "Responsable América Latina Programa Ciudades Sustentables, Fundación Avina",
    "instagram": "fundacionavina",
    "twitter": "fundacionAVINA",
    "facebook": null,
    "bio": "MBA e ingeniera en sistemas de información, con trayectoria en procesos y proyectos vinculados al desarrollo sostenible, en particular desde la intervención en espacios urbanos. Con interés y capacidad de vincular la innovación social, la gobernanza participativa y el uso de nuevas tecnologías en la transformación urbana hacia modelos más sustentables y resilientes. Conocimiento de Latinoamérica, a partir del acompañamiento e implementación de proyectos en más de 10 país de la región, los más recientes son la Iniciativa Regional de Ciudades Resilientes en alianza con BID Lab y 100RC, la Alianza Regional de Espacio Público con UN-Hábitat y Partícipes, alianza de gobernanza participativa con Unión Europea. Experiencia en la articulación de sectores diversos para el logro de objetivos comunes. Vínculo con organismos nacionales e internacionales."
  },
  {
    "type": "cc",
    "name": "Tamara Egger",
    "picture": "tamaraegger.jpg",
    "org": "Bid Cities Lab",
    "instagram": "bid_ciudades",
    "twitter": "BID_Ciudades",
    "facebook": null,
    "bio": "Tamara Egger es arquitecta-urbanista de Austria que aborda a la dimensión socioespacial de la vida urbana en América Latina. Actualmente es parte del equipo del LAB Ciudades de la División de Vivienda y Desarrollo Urbano del Banco Interamericano de Desarrollo (BID) cuyo objetivo es promover experimentaciones urbanas en América Latina y el Caribe.<br><br>Tamara está interesada en el urbanismo bottom-up, el potencial inherente de comunidades organizadas y la inteligencia colectiva de los ciudadanos.<br><br>En su trabajo para el LAB ciudades experimenta con herramientas de co-creacion de espacios urbanos para escalar estas experiencias a instrumentos de politicas publicas urbanas en la region de LAC.<br><br>Twitter: @EggTam<br><br>https://www.iadb.org/es/desarrollo-urbano-y-vivienda/lab-ciudades-bid"
  },
  {
    "type": "cc",
    "name": "José Chong",
    "picture": "josechong.jpg",
    "org": "ONUHabitat",
    "instagram": "onuhabitatlc",
    "twitter": "onuhabitat",
    "facebook": null,
    "bio": "Arquitecto y Planificador Urbano, enfocado el Desarrollo Urbano Sustentable y la Cooperación Internacional. UN - Habitat United Nations Human Settlements Programme"
  },
  {
    "type": "des",
    "name": "Flavia Broffoni",
    "picture": "flaviabroffoni.jpg",
    "org": "Activista",
    "instagram": "flaviabroffoni",
    "twitter": "FlaBroffoni",
    "facebook": null,
    "bio": "Politóloga especializada en relaciones internacionales, gestión ambiental y desarrollo regenerativo.<br>Oradora en TEDx Rio de la Plata.<br>Co-fundadora de Rebelión o Extinción Argentina.<br>Docente de ecología política y desarollo regenerativo."
  },
  // {
  //   "type": "des",
  //   "name": "Maristella Svampa",
  //   "picture": "maristellasvampa.jpg",
  //   "org": "Socióloga, escritora, investigadora anfibia",
  //   "instagram": "maristellasvampa",
  //   "twitter": "SvampaM",
  //   "facebook": "maristella.svampa",
  //   "bio": "Es Licenciada en Filosofía por la Universidad Nacional de Córdoba y Doctora en Sociología por la Escuela de Altos Estudios en Ciencias Sociales (EHESS) de París. Actualmente vive en Buenos Aires y es investigadora Superior del Conicet y Profesora Titular de la Universidad Nacional de La Plata. Ha recibido varios premios y reconocimientos, entre los cuales se destacan el Premio Kónex de platino en Sociología (2016) y el Premio Nacional de Ensayo Sociológico por su libro “Debates latinoamericanos. Indianismo, Desarrollo, Dependencia y Populismo” (2018).<br><br>Es coordinadora del Grupo de Estudios Críticos e interdisciplinarios sobre la Problemática Energética (www.gecipe.org), y desde 2011, miembro del Grupo Permanente de Alternativas al Desarrollo.<br><br>Se autodefine como una intelectual anfibia y una patagónica sempiterna que piensa en clave latinoamericana. Sus investigaciones abordan la crisis socioecológica, los movimientos sociales y la acción colectiva, así como problemáticas ligadas al pensamiento crítico y la teoría social latinoamericana.Tiene una veintena de libros publicados, entre ensayos, investigaciones y novelas. Sus últimos libros son Chacra 51. Regreso a la Patagonia en los tiempos del fracking (2018) y Las fronteras del neoextractivismo en América Latina (2018, el cual ha sido publicado en español, inglés y portugués)."
  // },
  {
    "type": "des",
    "name": "Eduard Muller",
    "picture": "eduardmuller.jpg",
    "org": "Rector de la Universidad para la Cooperación Internacional",
    "instagram": "EduardMuller",
    "twitter": "EduardMullerC",
    "facebook": null,
    "bio": "Fundador y rector de UCI con actividades profesionales más de 40 países en siete continentes. Reconocido globalmente por su trabajo en Desarrollo Regenerativo. Dirige la iniciativa Regenerate Costa Rica para convertir a Costa Rica en el primer país activamente regenerativo. Actualmente co-dirige una iniciativa conjunta para la regeneración de Costa Rica y Nueva Zelanda con el apoyo de Common Earth, adscrita al Commonwealth.<br><br>Miembro del World Intellectual Forum, India; Catedrático principal Cátedra UNESCO de Reservas de Biosfera y Sitios de Patrimonio; miembro del Consejo Científico de Cambio Climático – 4C de Costa Rica y; del Consejo Global de Wellbeing Economy Alliance – WEAll."
  },
  {
    "type": "des",
    "name": "Christopher Anderson",
    "picture": "christopheranderson.jpg",
    "org": "IPBES",
    "instagram": "dr.c.b.anderson",
    "twitter": null,
    "facebook": null,
    "bio": "Nacido en EE.UU. Desde 2000 vive en la Patagonia austral, empezando a los 22 años en el sur de Chile como co-fundador de una iniciativa que vinculaba las ciencias ecológicas y la filosofía ambiental. Ha logrado impactos en gestión, como la creación de la Reserva de Biosfera Cabo de Hornos. Desde 2012, reside en la parte argentina de Tierra del Fuego, siendo investigador del CONICET y profesor de la Universidad Nacional de Tierra del Fuego. Mi investigación y docencia abordan los sistemas socio-ecológicos, y aplica esta aproximación en la práctica como experto argentino ante la Plataforma Intergubernamental de Biodiversidad y Servicios Ecosistémicos."
  },
  {
    "type": "des",
    "name": "Marina Aizen",
    "picture": "marinaaizen.jpg",
    "org": "Periodistas por el Planeta",
    "instagram": "marinaaizen1,pxp_lac",
    "twitter": "PxP_LAC,marinaaizen",
    "facebook": "pxpLAC",
    "bio": "Periodista. Ex Corresponsal en Nueva York para Clarín. Editora de la revista Viva. Ahora, con Periodistas por el Planeta. Autora de Contaminados, una inmersión en la mugre del Riachuelo y de Trumplandia, una guía para entender los Estados Unidos. Tiene varios premios nacionales e internacionales por su cobertura de temas ambientales."
  },
  {
    "type": "lab",
    "name": "Ernesto L. Figueroa",
    "picture": "ernestolfigueroa.jpg",
    "org": "NQN-Lab",
    "instagram": "ernestol.figueroa",
    "twitter": "negrofigueroa13",
    "facebook": "ErnestoLFigueroa13",
    "bio": "Facilitador / Tallerista / Docente Universitario / Abogado<br>Director provincial de Gestión Estratégica, coordinador del NQN-LAB del Ministerio de Ciudadanía del Gobierno de Neuquén<br>Coordinador del Federal Lab, Laboratorio de Innovación Federal con equipos de 16 provincias y 30 municipios de la Mesa Federal de Particiapción Ciudadana. Co-creador del Método Che."
  },
  {
    "type": "lab",
    "name": "Lorena Ruiz",
    "picture": "lorenaruiz.jpg",
    "org": "Investigadora",
    "instagram": null,
    "twitter": null,
    "facebook": null,
    "bio": "Lorena Ruiz es socióloga. Explora los ámbitos relacionados con la dimensión social de la salud desde la docencia universitaria y la investigación.<br>Entre 2014 y 2018 fue mediadora cultural y responsable del Laboratorio de Innovación Ciudadana de Medialab Prado, donde aprendió sobre el papel de la mediación y la cultura colaborativa en la creación de comunidades de aprendizaje. A raíz de esta experiencia realiza formación y consultoría sobre laboratorios ciudadanos y procesos de cooperación público-social para diversas instituciones."
  },
  {
    "type": "lab",
    "name": "Christian Parra",
    "picture": "christianparra.jpg",
    "org": "PNUD Paraguay",
    "instagram": "cdparra",
    "twitter": "cdparra",
    "facebook": "cristhian.parra",
    "bio": "Cristian Parra es Ph.D. en Tecnologías de la Información y la Comunicación por la Universidad de Trento, Italia, e Ingeniero Informático por la Facultad Politécnica de la UNA. Lleva 10 años trabajando en proyectos I+D de informática social, aplicando métodos de diseño participativo y centrado en las personas en temas de salud pública comunitaria, inclusión social, tecnologías cívicas y participación ciudadana. Fue investigador postdoctoral de la Universidad de California, Berkeley, donde lideró los proyectos del Social Apps Lab (CITRIS). Fue consultor para el Banco Mundial, el BID, el SSI de Berkeley, entre otros. Actualmente, es Jefe de Experimentación del Laboratorio de Aceleración del PNUD. Antes de unirse a las Naciones Unidas, fue docente Investigador de la Universidad Católica de Asunción, donde lideró proyectos como TopaDengue, que combinó metodologías de participación comunitaria y tecnologías para combatir al Aedes Aegypti desde la propia comunidad, en el marco de un experimento controlado. Recibió una Mención Honorífica del Premio Nacional de Ciencia 2018 por algunos de estos trabajos, entre otros reconocimientos. Cristhian ha tenido siempre una pasión por el trabajo en las intersecciones, combinando ciencias sociales con ciencias de la computación, para informar el diseño, investigación, desarrollo e implementación de soluciones socio-técnicas innovadoras para desafíos sociales o comunitarios. Esta pasión lo trajo al espacio de los laboratorios de innovación, donde intenta incorporar lógicas de aprendizaje y experimentación a la acción por el desarrollo económico y social."
  },
  {
    "type": "lab",
    "name": "Javier Arteaga",
    "picture": "javierarteaga.jpg",
    "org": "Feeling",
    "instagram": "bienpensado",
    "twitter": "bienpensado",
    "facebook": "larevolucioncreativa",
    "bio": "Publicista, creador de la metodología para generar procesos de innovación denominada “Feeling” a través de la cual se busca solucionar problemas basándose los sentimientos del ser humano. Director de la Consultora de Pensamiento Feeling.<br>Consultor en temas de Gobierno Abierto e Innovación social.<br>Miembro fundador de la Red Latinoamérica de Innovación Política."
  },
  {
    "type": "lab",
    "name": "Mariana Salgado",
    "picture": "marianasalgado.jpg",
    "org": "Diseño y Diáspora",
    "instagram": "disenoydiaspora,mariansalgado",
    "twitter": "disenoydiaspora,Salgado",
    "facebook": "mariana.salgado",
    "bio": "Diseño y diáspora, el podcast de diseño social<br>Dr. Mariana Salgado, diseñadora de servicios trabajando actualmente en el Ministerio del Interior en Finlandia. Su trabajo se encuentra en la intersección entre políticas públicas y el diseño de servicios. Anteriormente trabajó en temas de salud global, inmigración y patrimonio cultural como investigadora en diseño y diseñadora de interacción. Hizo su doctorado y maestría en la Universidad de Aalto, en Laboratorio de nuevos medios. Hace un año y medio empezó un podcast: Diseño y diáspora, sobre diseño social. Obtuvo varios premios como diseñadora y es jurado de las becas nacionales de diseño en Finlandia."
  },
  {
    "type": "lab",
    "name": "Alexander Correa",
    "picture": "alexandercorrea.jpg",
    "org": "Platohedro",
    "instagram": "platohedro,",
    "twitter": "platohedro",
    "facebook": "platohedro",
    "bio": "Alexander Correa es sub-gestor cultural, co-fundador de la Corporación Platohedro. Tiene estudios en Ingeniería Industrial y Producción audiovisual, ha participado en la coordinación de equipos de trabajo para el Museo de Antioquia, Museo Arte Moderno de Medellín, Museo Casa de la Memoria, con experiencia en diseño y desarrollo de proyectos con incidencia en el trabajo colaborativo y apropiación tecnológica, pedagogías alternativas y además el acompañamiento en procesos de trabajo en red o coinspiraciones."
  },
  {
    "type": "lab",
    "name": "Paola Pollmeier",
    "picture": "paolapollmeier.jpg",
    "org": "Platos Sin Fronteras",
    "instagram": "platossinfronteras",
    "twitter": "paolapollmeier",
    "facebook": "PlatosSinFronteras.Colombia",
    "bio": "Paola Pollmeier es asesora y emprendedora social apoyando a personas y ciudades a COnectar, COsentir & COcrear con @platossinfronteras y @thecocreationagency. Ella fue líder de innovación abierta en el centro CTi del Municipio de Medellín donde dirigió un programa de participación ciudadana (MiMedellin), una red de innovación de ciudades (Cities for Life) y apoyó en la creación de la Estrategia de Datos Abiertos Metropolitana. Ella tiene su maestría de ciencia en gestión internacional y gobernanza y es una apasionada en crear movimientos innovadores y sociales. Su sueño siempre fue llevar su experiencia a proyectos comunitarios para mejorar directamente la calidad de vida de cada ciudadano.<br><br>Por eso creó PLATOS SIN FRONTERAS un movimiento local de gastronomía social que ofrece programas de educación nutricional e innovación en las comunidades más vulnerables de Medellín."
  },
  {
    "type": "pos",
    "name": "Uriel Fogué Herreros",
    "picture": "urielfogue.jpg",
    "org": "elii [oficina de arquitectura] / GCFP (Gabinete de Crisis de Ficciones Políticas)",
    "instagram": "elii_architecture",
    "twitter": "elii_info",
    "facebook": "eliiarchitectureoffice",
    "bio": "Doctor arquitecto (UPM). Profesor en la UEM. Codirige la oficina de arquitectura elii, que formó parte del Pabellón de España de la XV Bienal de Arquitectura de Venecia (León de Oro 2016). Cuenta con dos obras seleccionadas para los European Union Prize For Contemporary Architecture Mies Van Der Rohe Award (2015, 2019). Su obra Yojigen Poketto fue seleccionada en la exposición 'Home Stories 100 Years, 20 Visionary Interiors', Vitra Design Museum (2020). Codirige el Gabinete de Crisis de Ficciones Políticas. Es coautor del libro: What is Home Withour a Mother, premiado en la XIII BEAU 2015."
  },
  {
    "type": "pos",
    "name": "Ana Falú",
    "picture": "anafalu.jpg",
    "org": "CISCSA / UNC / RED MUJER Y HABITAT -HIC",
    "instagram": "ana.falu",
    "twitter": null,
    "facebook": "ana.falu",
    "bio": "Doctora arquitecta, profesora emérita, investigadora del Consejo Nacional de Investigaciones Científicas y Técnicas (CONICET) y directora del Instituto de Investigaciones de Vivienda y Hábitat (INVIHAB) de la Universidad Nacional de Córdoba, Argentina. Fue directora de ONU Mujeres (ex UNIFEM) para la Región Andina (2002-04) y para Brasil y Países del Cono Sur (2004-2009). Entre otros espacios de producción y acción a favor de los derechos de las mujeres, Ana Falú ha sido cofundadora de la Red Mujer y Hábitat de América Latina, de la Articulación Feminista Mercosur y de CISCSA (Córdoba, Argentina), organización de la que actualmente es su directora."
  },
  {
    "type": "pos",
    "name": "Javier Fernández Castro",
    "picture": "javierfernandezcastro.jpg",
    "org": "Secretario Nacional de Hábitat / IEH FADU-UBA",
    "instagram": "javierfernandezcastro7",
    "twitter": null,
    "facebook": null,
    "bio": "Secretaria de Hábitat, MDTyH / Instituto de la Espacialidad Humana UBA \"Nace en Buenos Aires en 1964. Arquitecto UBA FADU desde 1990.<br>Profesor Titular de Proyecto y Morfología en grado y diversos posgrados en UBA y otras escuelas latinoamericanas. Su práctica esta focalizada en el proyecto urbano orientado al hábitat popular, siendo autor de varios planes y proyectos. Ha merecido diversos primeros premios en concursos nacionales y bienales iberoamericanas. Desde 2018 dirige el Instituto de Investigaciones del Habitar de la UBA y desde marzo de 2020 se desempeña como Secretario de Hábitat en el nuevo Ministerio de Desarrollo Territorial y Hábitat de la Argentina.<br>Es miembro fundador de ALTeHA y ALEPH"
  },
  {
    "type": "pos",
    "name": "Zaida Muxí",
    "picture": "zaidamuxi.jpg",
    "org": "ETSAB-UPC",
    "instagram": "zaidamux",
    "twitter": "zaidamuxim",
    "facebook": "zaida.muxi",
    "bio": "Doctora arquitecta. profesora de la ETSAB. Experta en feminismo y género en relación a la arquitectura y el urbanismo. Experta en Vivienda. Autora de: La arquitectura de la ciudad global; Postsuburbia (Coord); Arquitectura y política. Ensayos para mundos alternativos (con Josep maria Montaner); Mujeres, Casas y ciudades. Más allá del umbral. Co-fundadora del Col·lectiu punt 6 y de Un día una arquitecta. Ha dado conferencias y cursos en numerosas ciudades y universidades, especialmente de Europa y América Latina"
  },
  {
    "type": "pos",
    "name": "Luciano Intile",
    "picture": "lucianointile.jpg",
    "org": "iR arquitectura",
    "instagram": "ir.arquitectura",
    "twitter": "IRarquitectura",
    "facebook": "IRarquitectura",
    "bio": "iR arquitectura es una construcción colectiva iniciada en el año 2008. Compuesta por arquitectos, diseñadores y entusiastas formados en distintas áreas académicas y disciplinares. Funciona como un sistema abierto, maleable y simbiótico; su naturaleza multidisciplinar le permite abordar la gestión integral del trabajo a diferentes escalas y perspectivas. iR arquitectura usa como motor los modelos en crisis, hace foco en problemáticas sociales, ambientales y económicas con el fin de ofrecer estrategias, modelos urbanísticos, arquitectónicos y objetuales pregnados de mayores registros de eficiencia energética en todas sus dimensiones. El trabajo de iR arquitectura ha sido premiado en concursos nacionales e internacionales, destacado en diversas publicaciones impresas y digitales, ha sido expuesto en el MARQ (Museo de Arquitectura de Buenos Aires), en el CMD (Centro Metropolitano de Diseño), han brindado conferencias en diversos ámbitos, entre los que se destacan Encuentros AE - Nuevas Generaciones Iberoamericanas en 2012, la convocatoria TEDx Río Limay en 2013, el congreso PA&S - UFLO Comahue 2015, el congreso CREA7 - Rosario 2015, el congreso CLA TIL 2016 en la Universidad de Morón, TRImarchi 17 y fue seleccionado para las bienales internacionales de arquitectura BIAAR, BA15, BA17, XBIAU y BAL2019."
  },
  {
    "type": "ciu",
    "name": "Adriana Ciocoletto",
    "picture": "adrianaciocoletto.jpg",
    "org": "Col·lectiu Punt 6",
    "instagram": "collectiupunt6",
    "twitter": "CollectiuPunt6",
    "facebook": "CollectiuPunt6",
    "bio": "Buenos Aires (1971). Actualmente reside en Barcelona (2003). Es Doctora Arquitecta y Urbanista. Integrante y cofundadora del Col·lectiu Punt 6 (2005), cooperativa de arquitectas, sociólogas y urbanistas de procedencias diversas con 15 años de experiencia local, estatal e internacional. Trabajamos para repensar los espacios domésticos, comunitarios y públicos con el fin de que promuevan la diversidad social sin discriminaciones de ningún tipo y para una transformación feminista de la sociedad. Para ello realizamos actividades participativas, formación, investigación, diseño de metodologías propias y consultorías con un único objetivo: conseguir ciudades y entornos más inclusivos donde las propias personas que los habitamos nos convirtamos en los especialistas de los espacios que nos rodean."
  },
  {
    "type": "ciu",
    "name": "Mariana Alegre",
    "picture": "marianaalegreescorza.jpg",
    "org": "Ocupa tu Calle",
    "instagram": "maralegre,ocupatucalle,limacomovamos",
    "twitter": "maralegre,ocupatucalle",
    "facebook": "marianaalegre",
    "bio": "Mariana Alegre es Máster en Diseño de Ciudades y Ciencias Sociales por la London School of Economics and Political Science (LSE) y becaria Chevening. Estudió Derecho en la PUCP y cuando realizó su maestría en Derechos Humanos supo que su pasión eran los derechos urbanos. Es Directora Ejecutiva en Lima Cómo Vamos, desde donde contribuyen a mejorar la calidad de vida de los limeños y chalacos. Es fundadora de la estrategia Ocupa Tu Calle que busca recuperar y generar más espacios públicos. Profesora en la Facultad de Gestión y Alta Dirección de la PUCP y profesora de Derecho a la Ciudad en la Maestría de Arquitectura, Urbanismo y Desarrollo Sostenible de la PUCP. Mariana investiga sobre distintos fenómenos urbanos, en particular, sobre la movilidad urbana sostenible, los espacios públicos y la efervescencia ciudadana. Es defensora de la desobediencia urbana. Escribe una columna semanal en el diario Perú 21. Mariana monta bicicleta y camina por su ciudad."
  },
  {
    "type": "ciu",
    "name": "Antonella Milano",
    "picture": "antonellamilano.jpg",
    "org": "Ecosistema Urbano",
    "instagram": "ecosistemaurbano",
    "twitter": "ecosistema",
    "facebook": "ecosistemaurbano",
    "bio": "Antonella Marlene Milano: Arquitecta / Urbanista / Experta en Participación / Ecosistema Urbano<br>Desde 2013 colaboro con Ecosistema Urbano, estudio de arquitectura y urbanismo con oficinas en Madrid, España, Boston y Miami, EE.UU. como coordinadora de proyectos. En el estudio soy responsable de las estrategias urbanas y del desarrollo de metodologías innovadoras que integran los mecanismos de participación y las herramientas digitales en los procesos de diseño. Con Ecosistema Urbano soy consultora de entidades como el Banco Mundial y el Banco Interamericano de Desarrollo para proyectos que van desde la definición de estrategias urbanas y territoriales hasta la implementación de proyectos piloto para la activación del espacio público.<br>Mi experiencia en procesos participativos empezó hace más de diez años, en el contexto de Apulia, Italia, con la organización de innovadoras acciones urbanas de activación del espacio público."
  },
  {
    "type": "ciu",
    "name": "Gustavo Dieguez",
    "picture": "gustavodieguez.jpg",
    "org": "A77",
    "instagram": "crisanaz,",
    "twitter": "crisanaz",
    "facebook": "gustavo.dieguez.9",
    "bio": "Es profesor titular de Arquitectura y Proyecto Urbano en FADU-UBA y de Experimentación Proyectual y Tecnológica en UNSAM. Integran el equipo de arquitectura a77 donde desarrollan trabajos vinculados con la autoconstrucción y la reutilización de restos industriales y el reciclaje aplicados a la vivienda experimental, a la formación de instituciones efímeras, a la activación de dinámicas sociales en el espacio público y a la autogestión de espacios culturales.<br>Es uno de los miembros fundadores del espacio IF /Investigaciones del Futuro, plataforma y espacio de pensamiento y producción de proyectos culturales y de inserción en entornos vulnerables.<br>Es autor de escritos y ponencias sobre asuntos urbanos y arquitectura. Sus trabajos construidos han tenido lugar en Buenos Aires, Barcelona y Nueva York y han sido exhibidos en múltiples exposiciones nacionales e internacionales."
  },
  {
    "type": "ciu",
    "name": "Alejandro Echeverri",
    "picture": "alejandroecheverri.jpg",
    "org": "Urbam",
    "instagram": null,
    "twitter": 'cachoecheverri',
    "facebook": null,
    "bio": "Arquitecto responsable en la transformación de Medellín. Especializado en Urbanismo Social. Centro de Estudios Urbanos y Ambientales de la Universidad @EAFIT Medellín."
  },
  {
    "type": "ciu",
    "name": "María Tomé",
    "picture": "mariatome.jpg",
    "org": "Oficina de Innovación Cívica",
    "instagram": "_mariatome",
    "twitter": "_MariaTome",
    "facebook": null,
    "bio": "Diseñadora Cívica, Arquitecta y Urbanista. Investigar y desarrolla proyectos en torno a la Innovación Cívica."
  },
  {
    "type": "ciu",
    "name": "Luciana Renner",
    "picture": "lucianarenner.jpg",
    "org": "Fundación Placemaking México",
    "instagram": "placemakingmx",
    "twitter": null,
    "facebook": null,
    "bio": "Arquitecta por la Universidad Nacional Autónoma de México y la Universidad de la Bauhaus en Weimar, Alemania. Cuenta con una maestría en Artes Visuales en alianza con la Universidad Pompeu Fabra en Barcelona, España. Es co-directora de la Fundación Placemaking México, un fondo que apoya programas y proyectos de espacio público con la comunidad. Fue coordinadora de programación del 2º Encuentro Placemaking Latinoamérica México 2018. Ha liderado proyectos de desarrollo sostenible relacionados con el espacio público, la movilidad y el agua, a través de procesos de participación ciudadana. Es docente en la Universidad Centro y ha impartido talleres y conferencias en diversos países"
  },
  {
    "type": "hab",
    "name": "Margarita Gutman",
    "picture": "margaritagutman.jpg",
    "org": "Observatorio de América Latina (OLA) en The New School University, de Nueva York",
    "instagram": "-",
    "twitter": null,
    "facebook": "margarita.gutman.5",
    "bio": "Margarita Gutman es arquitecta y doctora de la Universidad de Buenos Aires. Es profesora de Estudios Urbanos y Asuntos Internacionales y directora del Observatorio de América Latina (OLA) en The New School University, de Nueva York. También es Profesora Consulta ad-honorem y miembro de la Comisión de Doctorado de la Facultad de Arquitectura, Diseño y Urbanismo de la Universidad de Buenos Aires (FADU-UBA). De 2004 a 2009, ha sido profesora titular de una Cátedra de Historia de la Arquitectura en FADU-UBA. Es autora de numerosos trabajos de su especialidad, entre los que se cuenta el libro Buenos Aires El Poder de la Anticipación (2011)."
  },
  {
    "type": "hab",
    "name": "Pablo Vitale",
    "picture": "pablovitale.jpg",
    "org": "ACIJ",
    "instagram": null,
    "twitter": "pablovitale_",
    "facebook": null,
    "bio": "Co Director en ACIJ - Asociación Civil por la Igualdad y la Justicia<br>Especialista en problemáticas políticas y sociales urbanas, con foco en asentamientos populares.<br>Consultor, docente e investigador en ciencia política, problemáticas urbanas y fotografía."
  },
  {
    "type": "hab",
    "name": "Eduardo Resse",
    "picture": "eduardoreese.jpg",
    "org": "CELS",
    "instagram": null,
    "twitter": null,
    "facebook": null,
    "bio": "Investigador Docente de la Universidad Nacional de General Sarmiento Arquitecto y especialista en planificación urbana y regional. Co-responsable técnico y asesor de planes y proyectos urbanos en más de 30 ciudades argentinas. Subsecretario de Políticas Socioeconómicas del Ministerio de Desarrollo Humano del Gobierno de la Provincia de Buenos Aires, Consejero del Consejo de Planificación Urbana de la Ciudad de Buenos Aires, Secretario de Planificación de la Municipalidad de Avellaneda y Sub administrador General del Instituto de Vivienda de la Provincia de Buenos Aires. Actualmente, docente del Taller de Desarrollo Territorial de la licenciatura en Urbanismo del Instituto del Conurbano de la Universidad Nacional de General Sarmiento, de distintas maestrías en dicha universidad y en las de Buenos Aires, La Plata, Mar del Plata y Córdoba. Coordinador y docente del curso de desarrollo profesional “Gestión del Suelo en Grandes Proyectos Urbanos” del Lincoln Institute of Land Policy (Boston, EUA)."
  },
  {
    "type": "hab",
    "name": "Martin Motta",
    "picture": "martinmotta.jpg",
    "org": "IVC",
    "instagram": null,
    "twitter": "martinmotta",
    "facebook": null,
    "bio": "Doctor en Urbanismo de la Universidad de Buenos Aires. Arquitecto por la Universidad Nacional del Nordeste. Especialista en Planificación Urbana y Regional (PROPUR-FADU-UBA). Pasante en el Centro de Estudios Urbanos y Regionales (CEUR-CONICET). Ha sido docente de la cátedra de Gestión y Desarrollo de la Vivienda Popular (GDVP-FAU-UNNE), del Departamento de Diseño Arquitectónico y Urbano (FAU-UNNE) y actualmente lo es en la Cátedra de Política de Vivienda (PROPUR-FADU-UBA), la Cátedra de Infraestructura de Transporte y Ciudad (MPMU-UBA-TUB), el Módulo de Las Políticas y los programas nacionales de vivienda (FADU-UNC), la Cátedra de Planificación Urbana (EAEU-UTDT) y las Cátedras de Urbanismo I y II (DI-UNLAM). Ha participado en grupos de investigación del Instituto de Investigaciones para el Desarrollo de la Vivienda (IIDVi-FAU-UNNE), del Instituto de Planificación Urbana y Regional (IPUR-FAU-UNNE) y del Centro POIESIS (FADU-UBA) en temas relacionados con la política del hábitat y la vivienda en contextos urbanos. Es consultor independiente. Se ha desempeñado y actualmente continúan en el ámbito de la gestión pública (nivel nacional y local)"
  },
  {
    "type": "hab",
    "name": "Paola Siclari",
    "picture": "paolasiclari.jpg",
    "org": "Urbanista",
    "instagram": null,
    "twitter": null,
    "facebook": "paola.siclari",
    "bio": "Paola es arquitecta y urbanista con casi 20 años de experiencia profesional en desarrollo urbano en América Latina. Actualmente es consultora internacional, fue oficial de proyectos de ONU-Hábitat en la sede de Nairobi y coordinadora de investigación para el Ministerio de Vivienda y el Ministerio de Planificación en Chile."
  },
  {
    "type": "gob",
    "name": "Maria Buhigas",
    "picture": "mariabuhigas.jpg",
    "org": "Regidora del Ayuntamiento de Barcelona",
    "instagram": null,
    "twitter": "mariabuhigas",
    "facebook": null,
    "bio": "Maria Buhigas es arquitecta y urbanista. En 2014 funda su propia oficina - Urban Facts – colaborando con profesionales de distintas disciplinas para el desarrollo de estrategias espaciales y planificación urbana con un enfoque en los problemas económicos y sociales relacionados con las ciudades y las áreas metropolitanas. Antes de eso, trabajó en Barcelona Regional de 1999 a 2013, donde fue Directora de Estrategia Urbana desde 2008. Ha participado en numerosos foros internacionales y ha trabajado con diversos gobiernos locales y regionales, además de colaborar con agencias como el Banco Mundial y ONU-Hábitat. Tiene un título de arquitectura de la ETSAB-UPC y una Maestría en Planificación Urbana de la Universidad de Columbia, y actualmente es profesora asociada en la Universitat Autònoma de Barcelona."
  },
  {
    "type": "gob",
    "name": "Fabio Quetglas",
    "picture": "fabioquetglas.jpg",
    "org": "Diputado Nacional Argentino",
    "instagram": "fabioquetglas",
    "twitter": "fabiojquetglas",
    "facebook": "DiputadoFabioQuetglas",
    "bio": "Abogado (Universidad de Buenos Aires, 1988). Master en Gestión de Ciudades y desarrollo local (Universidad de Barcelona, 2004). Master en Internacionalización del Desarrollo Local (Universitá degli Studi di Bologna 2007). Director de Postgrado en Desarrollo Local y Gestión de Ciudades de la Universidad CAECE (2003-2005). Capacitador del Instituto Nacional de Capacitación Política en temas de Desarrollo Territorial. Actúa en el área de Investigación y en la formulación del Proyecto de Observatorio de Desarrollo que llevan adelante la Universidad Tecnológica Nacional en el Centro Tecnológico de Desarrollo Regional de \"\"Los Reyunos\"\". Profesor de Posgrado de Desarrollo Local y Economía Social UBA. Actualmente, es Diputado Nacional por la UCR."
  },
  {
    "type": "gob",
    "name": "Donka Atanassova",
    "picture": "donkaatanassova.jpg",
    "org": "Alcaldía de Bogotá",
    "instagram": "donka_at",
    "twitter": "DonkaAt",
    "facebook": "DonkaAtanassova",
    "bio": "Subdirectora del Instituto Distrital de la Participación y Acción Comunal de la Ciudad de Bogotá<br>\"Actual Subdirectora del Instituto Distrital de la Participación y Acción Comunal de la Ciudad de Bogotá. Es docente universitaria, consultora e investigadora de experiencias y problemas de “política, innovación y participación”. Conocedora de asuntos de seguridad, convivencia y gobierno.<br>Es parte de la Dirección del Equipo Político de Fuerza Común, red política compuesta por procesos organizativos, líderes y activistas que tiene como propósito trabajar por transformaciones en la vida, por la generación de pensamiento políticamente articulado y por la renovación política."
  },
  {
    "type": "gob",
    "name": "Lucía Abelenda",
    "picture": "luciaabelenda.jpg",
    "org": "AVINA",
    "instagram": "comluac",
    "twitter": "comluac",
    "facebook": null,
    "bio": "Uruguaya, residente en Ciudad de México. Licenciada en Sociología con énfasis en análisis organizacional y opinión pública, con posgrado en Ciencias Sociales realizado en FLACSO México.<br>Trabaja en Fundación Avina desde 2013, donde lidera la agenda de Tecnología para el Cambio Social que se enfoca en datos abiertos, tecnología cívica y gobierno abierto. En este trabajo ha contribuido a la creación y desarrollo de ALTEC, alianza que se enfoca en promover el desarrollo y uso de tecnología cívica inclusiva en AL. Asimismo, participó en la creación y crecimiento de ILDA, iniciativa enfocada en promover la agenda de datos abiertos. Apoyo la creación de Abrelatam- Condatos."
  },
  {
    "type": "gob",
    "name": "Sol González Sañudo",
    "picture": "solgonzalezsanudo.jpg",
    "org": "Sumando",
    "instagram": "sumando_arg",
    "twitter": "Sumando_arg",
    "facebook": "Sumando.arg",
    "bio": "Licenciada en Ciencia Política especializada en educación y cooperación para el desarrollo. Sol fue parte del equipo de jóvenes que co-creó Ágora, educando para la democracia en 2001, el primer proyecto educativo de lo que luego sería SUMANDO Argentina. Es directora ejecutiva desde 2012, luego de haber realizado un recorrido profesional dentro de otras organizaciones en Argentina y Brasil. Participó en el desarrollo y definición de políticas públicas de infancia y juventud. Confía en el trabajo colaborativo, la diversidad de voces y la participación de los múltiples actores involucrados en la vida política para la transformación social."
  },
  {
    "type": "staff",
    "name": "Carolina Huffmann",
    "org": "Urbanismo Vivo",
    "picture": "carolinahuffman.jpg",
    "instagram": "carohuffmann",
    "twitter": "CaroHuffmann",
    "facebook": null,
    "bio": ""
  },
  {
    "type": "staff",
    "name": "Cecilia Cianco",
    "org": "Urbanismo Vivo",
    "picture": "ceciliacianco.jpg",
    "instagram": "ceciciancio",
    "twitter": "ceci_ciancio",
    "facebook": null,
  },
  {
    "type": "staff",
    "name": "Doménico Di Siena",
    "org": "CivicWise", 
    "picture": "domenicodisiena.jpg",
    "instagram": "urbanohumano",
    "twitter": "urbanohumano",
    "facebook": "DiSienaDomenico",
    "bio": ""
  },
  {
    "type": "staff",
    "name": "Rosario Fassina",
    "org": "ACIJ",
    "picture": "rosariofassina.jpg",
    "instagram": "rofassina",
    "twitter": "rosario_f",
    "facebook": null,
    "bio": "Socia en Urbanismo Vivo. Arquitecta. Parte de CivicWise y Civic Innovation School.  Dedicada al diseño de procesos de  construcción y co-construcción."
  },
  {
    "type": "staff",
    "name": "Victor Franco López",
    "org": "Colectiva Habitaria",
    "picture": "victorfranco.jpg",
    "instagram": "victorfrancolopez",
    "twitter": "_victor_franco",
    "facebook": "victor.francolopez.90",
    "bio": ""
  },
  {
    "type": "staff",
    "name": "Analia Hanono",
    "org": "Urbanismo Vivo",
    "picture": "analiahanono.jpg",
    "instagram": "analiahanono",
    "twitter": null,
    "facebook": null,
    "bio": "Consultor Internacional e Investigador en procesos de Inteligencia Colectiva e Innovación Cïvica. Parte de CivicWise, Civic innovation School y Fairbnb.coop"
  },
  {
    "type": "staff",
    "name": "Melina Scioli",
    "org": "Artículo 41",
    "picture": "melinascioli.jpg",
    "instagram": "meliscioli",
    "twitter": "melinda_sc",
    "facebook": null,
    "bio": "Socia en Urbanismo Vivo.Arquitecta. Parte de CivicWise y Civic Innovation School. Dedicada al diseño de procesos de construcción y co-construcción."
  },
  {
    "type": "staff",
    "name": "Agustin Frizzera",
    "org": "Democracia en Red",
    "picture": "agustinfrizzera.jpg",
    "instagram": "agustinfrizzera",
    "twitter": "agustinfrizzera",
    "facebook": null,
    "bio": ""
  },
  {
    "type": "staff",
    "name": "Matias Lastra",
    "picture": "matiaslastra.jpg",
    "instagram": null,
    "twitter": null,
    "facebook": null,
    "bio": ""
  },
  {
    "type": "staff",
    "name": "Ana Bovino",
    "picture": "anabovino.jpg",
    "instagram": null,
    "twitter": null,
    "facebook": null,
    "bio": "Politóloga y cineasta, actualmente realizando un Máster en Documental de Creación en Barcelona. Siempre en el cruce entre el cine y la política, se ha desempeñado como productora e investigadora de archivo en documentales y ha realizado videos para proyectos y organizaciones sociales. Fue curadora en una galería de arte y Coordinadora de la Gerencia de Formación Artística del Complejo Teatral de Buenos Aires."
  },
  {
    "type": "staff",
    "name": "Guillermo Croppi",
    "org": "Democracia en Red",
    "picture": "guillermocroppi.jpg",
    "instagram": "guillermocroppi",
    "twitter": "guillermocroppi",
    "facebook": null,
    "bio": ""
  },
  {
    "type": "staff",
    "name": "Marina Pla",
    "org": "Artículo 41",
    "picture": "marinapla.jpg",
    "instagram": "marinaplastudio",
    "twitter": "marinapla",
    "facebook": "marinaplastudio",
    "bio": ""
  },
]